<template>
  <el-dialog
    :append-to-body="false"
    width="80%"
    :title="curRow.title"
    center=""
    :visible.sync="visible"
    :before-close="resetdialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form ref="elFormDom" inline :model="table.params" size="small">
      <el-form-item label="企业名称" prop="company_name">
        <el-input
          clearable
          v-model="table.params.company_name"
          placeholder="请输入"
          @keyup.enter.native.prevent="handleSearch"
        ></el-input>
      </el-form-item>
      <el-form-item label="岗位名称" prop="job_name">
        <el-input
          clearable
          v-model="table.params.job_name"
          placeholder="职位标题/岗位类型"
          @keyup.enter.native.prevent="handleSearch"
        ></el-input>
      </el-form-item>
      <el-form-item label="热门行业" prop="industry">
        <el-select
          v-model="table.params.industry"
          size="mini"
          filterable
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in industrylist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch"
          >查询
        </el-button>
        <el-button icon="el-icon-refresh-right" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button type="primary" size="small" @click="addCom"
        >添加企业</el-button
      >
    </div>
    <TablePlus
      :loading="table.loading"
      :data="table.data"
      :total="table.total"
      has-pagination
      :max-height="500"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <el-table-column type="index" label="序号" width="80" />
      <el-table-column prop="name" label="企业名称" show-overflow-tooltip />
      <el-table-column prop="industry_name" label="行业类型" show-overflow-tooltip />
      <el-table-column prop="legal" label="负责人" show-overflow-tooltip />
      <el-table-column prop="phone" label="注册账号" show-overflow-tooltip />
      <el-table-column prop="create_time" label="注册日期" show-overflow-tooltip />
      <el-table-column prop="publish_job_count" label="岗位数量" width="80" />
    </TablePlus>
    <addCompany ref="addCompanyRef" @refresh="refresh"></addCompany>
  </el-dialog>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
import TablePlus from "@/components/TablePlus";
import addCompany from "./addCompany.vue";
export default {
  name: "WealEdit",
  mixins: [mixinTable],
  components: {
    TablePlus,
    addCompany,
  },
  data() {
    return {
      companyList_: [],
      visible: false,
      loading: false,
      table: {
        loading: false,
        params: {
          page: 1,
          count: 10,
          company_name: "",
          job_name: "",
          industry: "",
        },
        data: [],
        total: 0,
      },
      curRow: null,
      industrylist: [
        { name: "农林牧渔业", id: 46 },
        { name: "制造业", id: 48 },
        { name: "批发和零售业", id: 51 },
        { name: "交通运输", id: 52 },
        { name: "住宿餐饮业", id: 53 },
        { name: "技术服务业", id: 54 },
        { name: "金融业", id: 55 },
        { name: "房地产业", id: 56 },
      ],
    };
  },
  methods: {
    reset() {
      this.$refs.elFormDom.resetFields();
      this.table.params.page = 1;
      this.getTable();
    },
    addCom() {
      let dom = this.$refs.addCompanyRef;
      dom.toggle(true);
      dom.getDetail(this.curRow);
      dom = null;
    },
    handleTabs() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    // 获取详情
    getDetail(row) {
      this.curRow = row;
      // this.getCompanyList();
      this.getTable();
    },
    refresh() {
      this.getTable();
      this.$emit("refresh");
    },
    getTable() {
      let params_ = {
        id: this.curRow.id,
        ...this.table.params,
      };
      this.table.loading = true;
      this.$http
        .get("/admin/fair/companyDetail", {
          params: params_,
        })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          }
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    resetdialog(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
  },
};
</script>
<style scoped>
.fs {
  padding: 0 0 20px;
}
</style>
